export const getDecimalPlaces = (num: number) => {
  const [, decimal] = `${num}`.split('.');
  return decimal?.length ?? 0;
};
